module.exports = __webpack_public_path__ + "img/terminacion.ecf50ffe.png";